import React from "react"

const ApprovedPages = () => {
  return <div>Approved Pages</div>
}

export default ApprovedPages
